import serviceModule from '@/store/modules/ServiceModule'
import { SnpMapping } from '@/services/connecteur'
import moment from 'moment'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'

@Module({ namespaced: true, name: 'snpMappingModule', dynamic: true, store })

export class SnpMappingModule extends VuexModule {
  private cache: SnpMapping[] = []

  private lastCacheUpdate!: Date

  @Mutation
  private updateCache (list: SnpMapping[]) {
    this.cache = list
    this.lastCacheUpdate = new Date()
  }

  @Mutation
  private updateSnpMappingCache (snpMapping: SnpMapping) {
    const index = this.cache.findIndex(c => c.id === snpMapping.id)
    if (index >= 0) {
      this.cache.splice(index, 1, snpMapping)
    } else {
      this.cache.push(snpMapping)
    }
  }

  @Action({ rawError: true })
  public async getSnpMappings (): Promise<SnpMapping[]> {
    try {
      if (this.isCacheExpired) {
        this.updateCache(await serviceModule.snpMappingApi.getAll())
      }
      return Promise.resolve(this.cache)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  @Action({ rawError: true })
  public async addSnpMapping (snpMapping: SnpMapping): Promise<SnpMapping> {
    try {
      const addedSnpMapping = await serviceModule.snpMappingApi.addSnpMapping(snpMapping)
      this.updateSnpMappingCache(addedSnpMapping)
      return addedSnpMapping
    } catch (error) {
      return Promise.reject(error)
    }
  }

  @Action({ rawError: true })
  public async updateSnpMapping (snpMapping: SnpMapping): Promise<SnpMapping> {
    try {
      const updatedSnpMapping = await serviceModule.snpMappingApi.updateSnpMapping(snpMapping)
      this.updateSnpMappingCache(updatedSnpMapping)
      return updatedSnpMapping
    } catch (error) {
      return Promise.reject(error)
    }
  }

  private get isCacheExpired (): boolean {
    if (!this.lastCacheUpdate) {
      return true
    }
    const duration = moment.duration(new Date().getTime() - this.lastCacheUpdate?.getTime())
    return duration.asMinutes() >= 5
  }
}

export default getModule(SnpMappingModule)
